import React from "react";

export const DeleteButton = ({ onClick, text = "Remove Task" }) => {
  return (
    <div className="flex justify-end items-end">
      <button
        type="button"
        onClick={onClick}
        className="bg-red-500 text-white px-4 py-2 rounded-xl mb-2"
      >
        {text}
      </button>
    </div>
  );
};

export const AddButton = ({ onClick, text = "Add New Task" }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="bg-blue-500 text-white px-4 py-2 rounded-xl w-full"
    >
      {text}
    </button>
  );
};

export const ProceedButton = ({ onClick }) => {
  return <AddButton onClick={onClick} text="Proceed" />;
};
